import { DEFAULT_APPCONFIG_ROUTES } from '@localstack/constants';
import { ReactElement } from 'react';
import { AppConfigCreateApplicationRequest, AppConfigUpdateApplicationRequest } from '@localstack/types';
import { Breadcrumbs, AppConfigApplicationForm, ProgressButton } from '@localstack/ui';
import { useAwsEffect, useAwsGetter, useRoutes } from '@localstack/services';
import { Box, Card, CardActions, CardContent, Typography } from '@mui/material';

import { useParams } from 'react-router-dom';

import { AppConfigProps } from './types';

export const AppConfigApplicationUpsert = ({
  Layout,
  clientOverrides,
  routes = DEFAULT_APPCONFIG_ROUTES,
}: AppConfigProps): ReactElement => {
  const { goto } = useRoutes();
  const { id } = useParams<'id'>();
  const { data: application } = useAwsGetter('AppConfig', 'getApplication', [{ ApplicationId: id }], {
    clientOverrides,
  });
  const { createApplication, updateApplication, isLoading } = useAwsEffect(
    'AppConfig',
    ['createApplication', 'updateApplication'],
    {
      clientOverrides,
      revalidate: ['listApplications'],
    },
  );
  const handleCreate = async (data: AppConfigCreateApplicationRequest) => {
    if (await createApplication(data)) {
      goto(routes.RESOURCES_APPCONFIG_APPLICATIONS);
    }
  };
  const handleUpdate = async (data: AppConfigUpdateApplicationRequest) => {
    if (await updateApplication({ ...data, ApplicationId: id || '' })) {
      goto(routes.RESOURCES_APPCONFIG_APPLICATION, { id });
    }
  };
  return (
    <Layout
      title={
        <Box>
          <Typography variant="h4">AppConfig Application</Typography>
          <Breadcrumbs
            mappings={[
              ['AppConfig', () => goto(routes.RESOURCES_APPCONFIG_APPLICATIONS)],
              [id, () => goto(routes.RESOURCES_APPCONFIG_APPLICATION, { id })],
              [application ? 'Update Application' : 'Create Application', null],
            ]}
          />
        </Box>
      }
      actions={
        <ProgressButton
          color="primary"
          variant="outlined"
          type="submit"
          form="AppConfigApplicationUpsert"
          loading={isLoading}
        >
          Submit
        </ProgressButton>
      }
    >
      <Card>
        <CardContent>
          <AppConfigApplicationForm
            formId="AppConfigApplicationUpsert"
            onSubmit={application ? handleUpdate : handleCreate}
            application={application}
            loading={isLoading}
          />
        </CardContent>
        <CardActions>
          <ProgressButton
            color="primary"
            variant="outlined"
            type="submit"
            form="AppConfigApplicationUpsert"
            loading={isLoading}
          >
            Submit
          </ProgressButton>
        </CardActions>
      </Card>
    </Layout>
  );
};
